module.exports = __webpack_public_path__ + "img/spezialisierungen_640.41cfb82b.png";